import { Option, Select, Stack, Typography } from "@mui/joy";
import { OperandSpec, ProblemSpec } from "../types";
import { ReactElement, useCallback, useId, useMemo } from "react";
import { useDispatch } from "react-redux";
import { updateProblemSpec } from "../store/pageSlice";
import { Operand } from "./Operand";

export interface DivisionProblemProps {
  model: ProblemSpec;
  sectionId: string;
}
export const DivisionProblem = ({ model }: DivisionProblemProps) => {
  const dispatch = useDispatch();
  const selectId = useId();

  const onOperandChange = useCallback(
    (operand: OperandSpec, index: number) => {
      const updatedOperands = [...model.operands];
      updatedOperands[index] = operand;
      dispatch(updateProblemSpec({ ...model, operands: updatedOperands }));
    },
    [dispatch, model]
  );
  const onRemaindersChange = useCallback(
    (_evt: any, newValue: boolean | null) => {
      const updatedValue = newValue === null ? false : newValue;
      const updatedModel: ProblemSpec = {
        ...model,
        params: { ...model.params, noRemainders: updatedValue },
      };
      dispatch(updateProblemSpec(updatedModel));
    },
    [dispatch, model]
  );
  const remainders = useMemo(() => {
    return model?.params?.["noRemainders"] === undefined
      ? false
      : model?.params?.["noRemainders"];
  }, [model]);
  const operandContent: Array<ReactElement> = model.operands.map(
    (operand, index) => {
      const ix = index;
      return (
        <Operand
          onChange={(op) => {
            onOperandChange(op, ix);
          }}
          key={index}
          operand={operand}
        />
      );
    }
  );
  return (
    <Stack key={model.id}>
      <Typography color="primary" level="body-xs">
        Remainders
      </Typography>
      <Select
        sx={{ width: "200px" }}
        value={remainders}
        onChange={onRemaindersChange}
        slotProps={{ button: { id: selectId } }}
      >
        <Option value={true}>None</Option>
        <Option value={false}>Some</Option>
      </Select>
      {operandContent}
    </Stack>
  );
};
